// Synthesized victory & spin sounds using Web Audio API.
// No binary asset dependency — works everywhere with no extra file to serve.

let _ctx = null;
function ctx() {
  if (typeof window === "undefined") return null;
  if (!_ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    _ctx = new AC();
  }
  // Some browsers (Safari/iOS) suspend the context until a user gesture.
  if (_ctx.state === "suspended") {
    try { _ctx.resume(); } catch { /* ignore */ }
  }
  return _ctx;
}

function note(frequency, startOffset, duration, type = "triangle", gain = 0.15) {
  const ac = ctx();
  if (!ac) return;
  const t0 = ac.currentTime + startOffset;
  const osc = ac.createOscillator();
  const g = ac.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(frequency, t0);
  g.gain.setValueAtTime(0, t0);
  g.gain.linearRampToValueAtTime(gain, t0 + 0.02);
  g.gain.exponentialRampToValueAtTime(0.001, t0 + duration);
  osc.connect(g);
  g.connect(ac.destination);
  osc.start(t0);
  osc.stop(t0 + duration);
}

// 🎺 Casino-style victory fanfare (~1.4s)
export function playVictory() {
  // C5, E5, G5, C6 ascending arpeggio + sparkle
  note(523.25, 0.00, 0.22, "triangle", 0.18);
  note(659.25, 0.18, 0.22, "triangle", 0.18);
  note(783.99, 0.36, 0.22, "triangle", 0.18);
  note(1046.5, 0.54, 0.45, "triangle", 0.22);
  // Sparkle high notes
  note(1568,   0.80, 0.10, "sine", 0.10);
  note(2093,   0.95, 0.10, "sine", 0.10);
  note(2637,   1.10, 0.18, "sine", 0.10);
}

// 🎰 Spinning click ticks (call repeatedly to simulate wheel deceleration)
export function playSpinTick(pitch = 1200) {
  const ac = ctx();
  if (!ac) return;
  const t0 = ac.currentTime;
  const osc = ac.createOscillator();
  const g = ac.createGain();
  osc.type = "square";
  osc.frequency.setValueAtTime(pitch, t0);
  g.gain.setValueAtTime(0.05, t0);
  g.gain.exponentialRampToValueAtTime(0.001, t0 + 0.05);
  osc.connect(g);
  g.connect(ac.destination);
  osc.start(t0);
  osc.stop(t0 + 0.05);
}

// 🪙 Small coin/gift chime
export function playGiftChime() {
  note(880, 0.00, 0.18, "sine", 0.15);
  note(1318.5, 0.10, 0.30, "sine", 0.15);
}

// 🎯 Casino-style "spin starting" whoosh
export function playSpinStart() {
  const ac = ctx();
  if (!ac) return;
  const t0 = ac.currentTime;
  const osc = ac.createOscillator();
  const g = ac.createGain();
  osc.type = "sawtooth";
  osc.frequency.setValueAtTime(220, t0);
  osc.frequency.exponentialRampToValueAtTime(880, t0 + 0.6);
  g.gain.setValueAtTime(0.0, t0);
  g.gain.linearRampToValueAtTime(0.08, t0 + 0.05);
  g.gain.exponentialRampToValueAtTime(0.001, t0 + 0.6);
  osc.connect(g); g.connect(ac.destination);
  osc.start(t0); osc.stop(t0 + 0.6);
}
